.verification-code {
    display: flex;
    height: 49px;
    padding: 7px 8px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    border-radius: 3px;
    background: #eff5f7;
    color: #337da8;
    margin-top: 6px;
}
